import Ajv from 'ajv';
import workflowFlowSchema from './workflowFlowSchema.json';

const ajv = new Ajv({ allErrors: true });
const validateSchema = ajv.compile(workflowFlowSchema);

/**
 * Validate a flow object { nodes, edges } against the workflow JSON schema.
 * @param {object} flow - { nodes: [...], edges: [...] }
 * @returns {{ valid: boolean, errors: Array<{ path: string, message: string }> }}
 */
export function validateFlowWithSchema(flow) {
  const valid = validateSchema(flow);
  if (valid) {
    return { valid: true, errors: [] };
  }
  const errors = (validateSchema.errors || []).map((err) => ({
    path: err.instancePath || err.schemaPath || '',
    message: err.message || 'Validation error'
  }));
  return { valid: false, errors };
}
